(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["satin-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('satin-product')) {
  customElements.define('satin-product', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      this.setAttribute('data-ready', '');
      this.querySelectorAll('[data-thumbs],button[data-step]').forEach(el => el.hidden = false);
      const quantity = this.querySelector('input[name="quantity"]');
      const select = this.querySelector('[data-variant]');
      const showImage = data => {
        const image = this.querySelector('.sp__image');
        if (!image || !data.photo) return;
        image.removeAttribute('srcset');
        image.src = data.photo;
        image.alt = data.alt || '';
        this.querySelector('[data-hero-link]').href = data.full || data.photo;
        this.querySelectorAll('[data-thumbs] button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageId === data.imageId)));
      };
      this.querySelectorAll('[data-thumbs] button').forEach(button => button.addEventListener('click', () => showImage(button.dataset)));
      this.querySelectorAll('button[data-step]').forEach(button => button.addEventListener('click', () => {
        if (!quantity) return;
        if (!quantity.value || !quantity.validity.valid) quantity.value = quantity.min || '1';
        if (button.dataset.step === '1') quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      select?.addEventListener('change', () => {
        const data = select.selectedOptions[0].dataset;
        this.querySelector('[data-price]').textContent = data.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = data.compare;
        compare.hidden = !data.compare;
        const available = data.available === 'true';
        this.querySelector('[data-submit]').disabled = !available;
        this.querySelector('[data-button-text]').textContent = available ? this.dataset.add : this.dataset.sold;
        quantity.min = data.min || '1';
        quantity.step = data.step || '1';
        if (data.max) quantity.max = data.max; else quantity.removeAttribute('max');
        if (!quantity.validity.valid) quantity.value = quantity.min;
        showImage(data);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
